import I18n from 'I18n';
export default ((amount, currencyCode) => {
  return I18n.text('i18n.numberRepresentation.numberWithCurrencyCode', {
    amountNumberValue: amount,
    currencyCode
  });
});